import { request } from '@/utils/request'
import official_request from '@/utils/official-request'

export function login(data) {
  return request({
    url: '/plaintiff/api/home/def/user/login',
    method: 'post',
    data
  })
}
// 获取用户详情设置
export function getInfo(authKey) {
  return request({
    url: '/plaintiff/api/person/personInfo',
    method: 'get'
  })
}

// 获取网站详情设置
export function GetPcSet() {
  return official_request({
    url: '/plaintiff/api/home/getImgsByOrgCode',
    method: 'get'
  })
}

export function logout(data) {
  return request({
    url: '/admin/base/logout',
    method: 'post',
    data
  })
}
